/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../Body/Body.css";
import MediaQuery from "react-responsive";
const Form = lazy(() => import("../../components/SignUpForm/SignUpForm"));
const Interior = lazy(() => import("../../components/Interior/Interior"));



export default function Body({ links }) {
  const imgCDNURL = process.env.REACT_APP_DENVER_CDN_URL;

  return (
    <>
      <div className="banner">
        <Container>
          <Row>
            <Col sm={12} md={12} xl={6} lg={6}>
              <div className="bannertextstag">
                <p className="mastertitle">
                  Free Ai Lead Prospecting:<br />
                  The Rise of Angel Ai Life,<br />
                  Nothing is Beyond Reach™
                </p>
                {/* <ul className="word-list">
                  <li>No Tough Loans</li>
                  <li className="orange-bullet">
                    <span>Close Fast</span>
                  </li>
                  <li>Earn More</li>
                </ul> */}
              </div>
              <div className="mstar-container">
                <p className="eventname">The Real Estate Evolution with Ai:<br />
                  <span className="eventname1" style={{ color: '#FFF' }}>Insights from Angel Ai Denver Forum</span></p>
              </div>
              <div className="angelailogocont">
                <a href="https://angelai.com/"
                  target="_blank"
                  rel="noreferrer"
                  title="Angel AI"
                  className="angelailogoancher">
                  <img src={imgCDNURL + "angelai-banner.webp"} alt="Angel Ai" className="angelailogo" />
                </a>
              </div>
            </Col>
            <Col sm={12} md={12} xl={6} lg={6}>
              <div className="formsection">
                <Suspense fallback={<div />}>
                  <Form />
                </Suspense>
              </div>
            </Col>
          </Row>
          <MediaQuery query="(min-width: 992px)">
            <Suspense fallback={<div />}>
              <Interior links={links} />
            </Suspense>
          </MediaQuery>
        </Container>
      </div>
    </>
  );
}
